import { render, staticRenderFns } from "./CandidatoForm.vue?vue&type=template&id=370d34a4"
import script from "./CandidatoForm.vue?vue&type=script&lang=js"
export * from "./CandidatoForm.vue?vue&type=script&lang=js"
import style0 from "./CandidatoForm.vue?vue&type=style&index=0&id=370d34a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports